"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.drawer.preview': '内容与预览',
    'socialMediaPlan.drawer.ai': 'AI分析',
    'socialMediaPlan.drawer.platforms': '平台',
    'socialMediaPlan.drawer.date': '日期',
    'socialMediaPlan.drawer.type': '类型',
};
